import { jsx } from "react/jsx-runtime";
import { cleanProps, cn } from "../../utils/index.js";
import { textVariants, textVariantsFields } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const labelVariants = tv({
    extend: textVariants
});
function Label({ children, className, ...restProps }) {
    const classes = cn(labelVariants(restProps), className);
    return /*#__PURE__*/ jsx("label", {
        className: classes,
        ...cleanProps(restProps, [
            ...textVariantsFields
        ]),
        children: children
    });
}
export { Label };
